<template>
  <div class="more-search">
    <div class="more-search__btns">
      <Button type="primary" @click.stop="toggleShow('showInput', true)">模糊搜索</Button>
      <Button @click.stop="gotoPage('addLib')">新增</Button>
    </div>
    <div class="more-search-input" v-if="showInput">
      <Input v-model="key" placeholder="模糊搜索关键词" style="width: 210px" />
      <Button @click="search">搜索</Button>
      <div class="search-count count-num" v-if="!loading && data.length !== 0">模糊搜索出 <span class="blue">{{count}}</span> 个结果</div>
    </div>
    <div class="more-search__table" v-loading="loading" v-if="show">
      <page-table
        :loading="loading"
        :col="col"
        :data="data"
        :hasFixed="true"
        @compFn="compFn"
      ></page-table>
    </div>
  </div>
</template>
<script>
import pageTable from '@/components/pageCom/pageTable'

export default {
  components: { pageTable },
  data() {
    return {
      showInput: false, // 是否显示模糊搜索按钮
      show: false, // 是否显示模糊搜索结果
      key: '', // 搜索词
      loading: false,
      count: '',
      col: [],
      data: []
    }
  },
  methods: {
    gotoPage(name) {
      this.$router.push({ name: name })
    },
    toggleShow(type, flag) {
      this[type] = flag
    },
    search() {
      this.toggleShow('show', true)
      this.loading = true
      setTimeout(() => {
        setTimeout(() => {
          this.loading = false
          this.count = Math.floor(Math.random() * 100)
          this.col = [
            { field: 'radio', title: '选择', width: 50, titleAlign: 'left', columnAlign: 'left', componentName: 'cleanListRadio' },
            { field: 'operate', title: '操作', width: 90, titleAlign: 'left', columnAlign: 'left', componentName: 'cleanListOpe' },
            { field: 'name', title: '姓名', width: 220, isResize: true, titleAlign: 'left', columnAlign: 'left' },
            { field: 'tel', title: '手机号码', width: 220, isResize: true, titleAlign: 'left', columnAlign: 'left' },
            { field: 'hobby', title: '爱好', width: 220, isResize: true, titleAlign: 'left', columnAlign: 'left' },
            { field: 'address', title: '地址', width: 220, isResize: true, titleAlign: 'left', columnAlign: 'left' }
          ]
          this.data = [
            { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
            { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
            { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
            { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
            { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
            { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
            { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
            { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
            { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
            { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
            { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
            { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
            { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
            { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
            { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
            { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
            { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
            { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
            { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' }
          ]
        }, 200)
      })
    },
    pageChange() {
    },
    pageSizeChange() {
    },
    // 表格内操作
    compFn(params) {
      if (params.type === 'del') {
        this.$emit('toggleDelDiag', true)
      } else if (params.type === 'setRadio') {
        this.$emit('updateSel', params.index)
        this.data.map((item, index) => {
          item.isSel = index === params.index
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped="">
  .more-search__btns {
    text-align: center;
    margin-bottom: 24px;
    .ivu-btn {
      width: 83px;
    }
  }
  .more-search-input {
    margin-bottom: 18px;
    position: relative;
    .count-num {
      bottom: 0;
    }
    .ivu-input-wrapper {
      margin-right: 10px;
      vertical-align: bottom;
    }
  }
</style>
